import { nullSafeToString, toDisplayPrice } from '../lib/util';

/**
 * A promotion applied to an {@link Order Order}.
 *
 * @property {number} id - (Read only) This order promotion's unique id.
 * @property {?number} promotionId - (Read only) The id of the promotion itself, which other orders may also have used.
 * @property {string} name - (Read only) The promotion's name.
 * @property {number} discountPrice - (Read only) How much this promotion took off the order.
 * @property {string} displayDiscountPrice - (Read only) this.discountPrice formatted with commas and two decimal places.
 */

class OrderPromotion {
    constructor (data = {}) {
        this.id = data.id;
        this.promotionId = (data.promotion && data.promotion.id) || null;
        this.name = nullSafeToString(data.promotion && data.promotion.name);
        this.discountPrice = data.discountPrice || 0;
        this.displayDiscountPrice = toDisplayPrice(this.discountPrice);

        Object.freeze(this);
    }
}

export default OrderPromotion;
